import type { Feed, FeedEntry, UIComponent } from '~/services/layout/index.ts';
import { getPluginConfig } from '~/utils/get-plugin-configuration.ts';
import manifest from '../config/manifest.ts';
import logger from '~/services/logger/index.ts';

export default function WebviewComponent({
  uiComponent,
  feed,
}: {
  uiComponent: UIComponent;
  feed?: Feed;
}): JSX.Element {
  const config = getPluginConfig<typeof manifest>(manifest, uiComponent);

  const {
    general: { webview_accessibility_title, url },
  } = config;

  try {
    const firstEntry: FeedEntry | undefined = feed?.entry[0];

    const src = url || firstEntry?.link?.href;

    if (!src) return <></>;

    return (
      <section
        className={`component-${uiComponent.id} component-classes relative h-webview w-full overflow-hidden border-none`}
      >
        <iframe
          title={webview_accessibility_title || 'iframe'}
          allowFullScreen={true}
          sandbox="allow-same-origin allow-scripts allow-forms allow-top-navigation"
          src={src}
          className="h-full w-full"
        />
      </section>
    );
  } catch (error: any) {
    logger.info(`Webview component: ${error.message}`);
    return <></>;
  }
}
